import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useVoiceAssistant } from '@livekit/components-react';
export function AgentUI({ setAgentIsReady }) {
    const { state: assistantState, audioTrack: assistantAudio, videoTrack: assistantVideo, } = useVoiceAssistant();
    useEffect(() => {
        if (assistantState === 'connecting') {
            setAgentIsReady(true);
        }
        else {
            setAgentIsReady(false);
        }
    }, [assistantState]);
    return _jsx(_Fragment, {});
}
